@if ((error$ | async)?.show) {
  <div class="alert-message">
    <strong> {{ (error$ | async)?.status }}:</strong>
    {{ (error$ | async)?.message }}
    <button (click)="dismissError()"><app-icon name="cross" width="16px" height="16px" /></button>
  </div>
}

@if ((newVersion$ | async)?.show) {
  <div class="alert-message">
    <strong>Application has been updated to the newest version.</strong>
    <button (click)="dismissNewVersion()"><app-icon name="cross" width="16px" height="16px" /></button>
  </div>
}
